'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _elementCountActions = require('./elementCountActions');

var _popupActions = require('../../components/popupPanel/popupActions');

var _elementCountSelector = require('./elementCountSelector');

var _currentUserSelector = require('../currentUserSelector');

var _elementHelper = require('../../../common/elements/elementHelper');

var _elementMoveActionUtil = require('../../element/elementMoveActionUtil');

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _notificationUtils = require('../../../common/notifications/notificationUtils');

var _elementConstants = require('../../../common/elements/elementConstants');

var _elementCountConstants = require('./elementCountConstants');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } // Lib


// Actions


// Selectors


// Utils


// Constants


/**
 * Creations or deletions (of new elements) don't need to perform any requests to the server to find child elements
 * (as there won't be any).
 */
var createNewElementModifyCountMiddlewareFn = function createNewElementModifyCountMiddlewareFn(transformCountElementFn) {
    return function (store, action) {
        var elementType = action.elementType;
        // dispatch an action to reduce the element count based on the type of the element
        store.dispatch(transformCountElementFn(_defineProperty({}, elementType, 1), action.transactionId));
    };
};

var increaseCountNewElement = createNewElementModifyCountMiddlewareFn(_elementCountActions.increaseElementCount);
var reduceCountNewElement = createNewElementModifyCountMiddlewareFn(_elementCountActions.increaseElementCount);

var createModifyCountMiddlewareFn = function createModifyCountMiddlewareFn(transformCountElementFn, transformCountContainerFn) {
    return function (store, action) {
        var state = store.getState();
        var currentUserId = (0, _currentUserSelector.getCurrentUserId)(state);

        // If the action is a create or delete the || case will be used
        var moves = action.moves || [(0, _lodash.pick)(action, ['id', 'location', 'from'])];
        var movedElementsOfInterest = moves.filter(_elementMoveActionUtil.isMoveToOrFromTrash).map(function (_ref) {
            var id = _ref.id;
            return state.getIn(['elements', id]);
        }).filter((0, _elementHelper.isElementCreatedByUser)(currentUserId));

        // NOTE: This assumes that multi-moves will only ever all be to trash or from trash.
        var countsMap = movedElementsOfInterest.reduce(_notificationUtils.reduceTypeCounts, {});

        // If there's no changes in the element count then no need to continue
        if ((0, _lodash.reduce)(countsMap, _lodash.add, 0) <= 0) return;

        // dispatch an action to reduce the element count based on the type of the element
        store.dispatch(transformCountElementFn(countsMap, action.transactionId));

        movedElementsOfInterest.filter(_elementHelper.isContainer).forEach(function (element) {
            // if the element is a container, also fetch it's children count and remove those as well
            var elementId = (0, _elementHelper.getPhysicalId)(element);
            store.dispatch(transformCountContainerFn(elementId, action.transactionId));
        });
    };
};

var increaseCount = createModifyCountMiddlewareFn(_elementCountActions.increaseElementCount, _elementCountActions.fetchBoardDescendantCountAndIncrease);

var reduceCount = createModifyCountMiddlewareFn(_elementCountActions.decreaseElementCount, _elementCountActions.fetchBoardDescendantCountAndDecrease);

// only these actions will change the count
// otherwise, ignore the action
var actionTypePredicate = function actionTypePredicate(action) {
    switch (action.type) {
        case _elementConstants.ELEMENT_DELETE:
        case _elementConstants.ELEMENT_CREATE:
        case _elementCountConstants.ELEMENT_COUNT_INCREAESE:
        case _elementCountConstants.ELEMENT_COUNT_DECREASE:
            return true;
        case _elementConstants.ELEMENT_MOVE_MULTI:
            return action.moves.some(_elementMoveActionUtil.isMoveToOrFromTrash);
        default:
            return false;
    }
};

var remoteActionPredicate = function remoteActionPredicate(action, state) {
    // if action is local, we care about it
    if (!action.remote) return true;

    var element = state.getIn(['elements', action.id]) || action;
    if (!element) return false;

    // if element is a container, we care about it even if it's isn't created by
    // the current user because it could contain elements we care about
    var elementType = (0, _immutableHelper.prop)('elementType', element);
    if ((0, _elementHelper.isContainer)(elementType)) return true;

    // if element isn't a container, check the creator - we only care about
    // elements created by the current user
    var currentUserId = state.getIn(['app', 'currentUser', '_id']);
    var elementCreator = (0, _immutableHelper.propIn)(['meta', 'creator'], element);

    return elementCreator && elementCreator === currentUserId;
};

var actionPredicate = function actionPredicate(action, state) {
    return actionTypePredicate(action) && remoteActionPredicate(action, state);
};

var elementCountTrackingMiddleware = function elementCountTrackingMiddleware(store) {
    return function (next) {
        return function (action) {
            if (action.isUndo || action.isRedo) return next(action);

            // NOTE: Here we're assuming that the move is either a deletion or addition, but it can't be both
            //  Need to change this in the future if this proves to be incorrect
            if (action.type === _elementConstants.ELEMENT_MOVE_MULTI && action.moves.some(_elementMoveActionUtil.isMoveToTrash)) {
                reduceCount(store, action);
            }
            if (action.type === _elementConstants.ELEMENT_MOVE_MULTI && action.moves.some(_elementMoveActionUtil.isMoveFromTrash)) {
                increaseCount(store, action);
            }

            if (action.type === _elementConstants.ELEMENT_DELETE) {
                reduceCountNewElement(store, action);
            }

            if (action.type === _elementConstants.ELEMENT_CREATE) {
                increaseCountNewElement(store, action);
            }

            return next(action);
        };
    };
};

// this will intercept element create actions and stop them from occurring
// when the user's element count has been exceeded
var elementCreationInterceptMiddleware = function elementCreationInterceptMiddleware(store) {
    return function (next) {
        return function (action) {
            if (action.remote || action.type !== _elementConstants.ELEMENT_CREATE) return next(action);

            var elementType = action.elementType,
                duplicate = action.duplicate;


            var state = store.getState();

            if (!(0, _elementHelper.isContainer)(elementType) || duplicate) {
                var totalContent = (0, _elementCountSelector.contentTotalCountSelector)(state);
                var totalContentLimit = (0, _elementCountSelector.contentTotalLimitSelector)(state);

                if (totalContent >= totalContentLimit) return store.dispatch((0, _popupActions.openPopup)(_elementCountConstants.ELEMENT_COUNT_LIMIT_POPUP));
            }

            return next(action);
        };
    };
};

exports.default = function (store) {
    return function (next) {
        return function (action) {
            var state = store.getState();

            // only count if the action is of interest
            if (!actionPredicate(action, state)) return next(action);

            return elementCreationInterceptMiddleware(store)(elementCountTrackingMiddleware(store)(next))(action);
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/elementCount/elementCountMiddleware.js
// module id = 2109
// module chunks = 0